import React from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';

import styles from './pageLoading.module.scss';

export default function PageLoading(): JSX.Element {
    return (
        <div className={styles.pageLoading}>
            <ProgressCircle />
        </div>
    );
}
